import { constants } from "../constants/redux-constants";

export const change_app_language = (payload) => {
  return { type: constants.CHANGE_LANGUAGE, payload };
};
export const change_audio_language = (payload) => {
  return { type: constants.AUDIO_LANGUAGE, payload };
};
export const handle_print_watermark = (payload) => {
  return { type: constants.PRINT_WATERMARK, payload };
};
export const change_theme = (payload) => {
  return { type: constants.APP.CHANGE_THEME, payload };
};
export const change_login = (type) => {
  return { type: type };
};
export const reset_state = () => {
  return { type: constants.RESET };
};
export const add_user_data = (payload) => {
  return { type: constants?.USER_DATA, payload };
};
export const toggle_loader = (payload) => {
  return { type: constants?.APP.TOGGLE_LOADER, payload };
};
export const offline_fallback = (payload) => {
  return { type: constants?.APP.OFFLINE_FALLBACK, payload };
};
export const full_page_loader = (payload) => {
  return { type: constants?.APP.FULL_PAGE_LOADER, payload };
};
export const generate_notification = (payload) => {
  return { type: constants?.APP?.GENERATE_NOTIFICATIONS, payload };
};
export const read_notifications = () => {
  return { type: constants?.APP?.READ_NOTIFICATIONS };
};
export const clear_notification = () => {
  return { type: constants?.APP?.CLEAR_NOTIFICATIONS };
};
export const delete_notification = (payload) => {
  return { type: constants?.APP?.DELETE_NOTIFICATIONS, payload };
};
export const set_dashboard_loaded = (payload) => {
  return { type: constants?.SET_DASHBOARD_LOADED, payload };
};

export const set_isDirty = (payload) => {
  return { type: constants?.SET_IS_DIRTY, payload };
};

export const set_edit_widget = (payload) => {
  return { type: constants?.APP?.EDIT_WIDGET, payload };
};

export const save_session_context = (payload) => ({
  type: constants?.APP?.SAVE_SESSION_CONTEXT,
  payload,
});
export const save_agent_context = (payload) => ({
  type: constants?.APP?.SAVE_AGENT_CONTEXT,
  payload,
});
